import { ACTION_SELECT_DROPDOWN_STYLES } from '../../Action'

const TABLE_ROW_CONTEXT_ACTIONS_MENU_MAX_HEIGHT = 360

export const TABLE_ROW_CONTEXT_ACTIONS_DROPDOWN_STYLES = {
  ...ACTION_SELECT_DROPDOWN_STYLES,
  maxHeight: TABLE_ROW_CONTEXT_ACTIONS_MENU_MAX_HEIGHT,
}

export const QA_NAME_TABLE_ROW_ACTIONS = 'itemActionsMenu'
